let lastId = 0;

export const newId = (prefix = 'id'): string => {
  return `${prefix}${++lastId}`;
};
